import * as MutationHelpers from 'shared/helpers/vuex/mutationHelpers';
import WgptSocialMediaPostsAPI from '../../api/wgpt/socialMediaPosts';
import types from '../mutation-types';
import { throwErrorMessage } from '../utils/api';

export const state = {
  records: [],
  meta: {},
  uiFlags: {
    isFetching: false,
    isFetchingItem: false,
    isCreating: false,
    isRemoving: false,
  },
};

export const getters = {
  getSocialMediaPosts($state) {
    return $state.records;
  },
  getSocialMediaPost: $state => id => {
    return $state.records.find(record => record.id === Number(id)) || {};
  },
  getMeta($state) {
    return $state.meta;
  },
  getUIFlags($state) {
    return $state.uiFlags;
  },
};

export const actions = {
  get: async ({ commit }, params) => {
    commit(types.SET_WGPT_SOCIAL_MEDIA_POST_UI_FLAG, { isFetching: true });
    try {
      const response = await WgptSocialMediaPostsAPI.get(params);
      commit(types.SET_WGPT_SOCIAL_MEDIA_POSTS_META, response.data.meta);
      commit(types.SET_WGPT_SOCIAL_MEDIA_POSTS, response.data.payload);
      return response.data;
    } catch (error) {
      return throwErrorMessage(error);
    } finally {
      commit(types.SET_WGPT_SOCIAL_MEDIA_POST_UI_FLAG, { isFetching: false });
    }
  },
  show: async ({ commit }, id) => {
    commit(types.SET_WGPT_SOCIAL_MEDIA_POST_UI_FLAG, { isFetchingItem: true });
    try {
      const response = await WgptSocialMediaPostsAPI.show(id);
      commit(types.ADD_WGPT_SOCIAL_MEDIA_POST, response.data);
      return response.data;
    } catch (error) {
      return throwErrorMessage(error);
    } finally {
      commit(types.SET_WGPT_SOCIAL_MEDIA_POST_UI_FLAG, {
        isFetchingItem: false,
      });
    }
  },
  create: async ({ commit }, payload) => {
    commit(types.SET_WGPT_SOCIAL_MEDIA_POST_UI_FLAG, { isCreating: true });
    try {
      const response = await WgptSocialMediaPostsAPI.create(payload);
      commit(types.ADD_WGPT_SOCIAL_MEDIA_POST, response.data);
      return response.data;
    } catch (error) {
      return throwErrorMessage(error);
    } finally {
      commit(types.SET_WGPT_SOCIAL_MEDIA_POST_UI_FLAG, { isCreating: false });
    }
  },
  remove: async ({ commit }, id) => {
    commit(types.SET_WGPT_SOCIAL_MEDIA_POST_UI_FLAG, { isRemoving: true });
    try {
      const response = await WgptSocialMediaPostsAPI.remove(id);
      commit(types.ADD_WGPT_SOCIAL_MEDIA_POST, response.data);
      return response.data;
    } catch (error) {
      return throwErrorMessage(error);
    } finally {
      commit(types.SET_WGPT_SOCIAL_MEDIA_POST_UI_FLAG, { isRemoving: false });
    }
  },
};

export const mutations = {
  [types.SET_WGPT_SOCIAL_MEDIA_POST_UI_FLAG]($state, data) {
    $state.uiFlags = { ...$state.uiFlags, ...data };
  },
  [types.SET_WGPT_SOCIAL_MEDIA_POSTS_META]($state, data) {
    $state.meta = data;
  },
  [types.SET_WGPT_SOCIAL_MEDIA_POSTS]: MutationHelpers.set,
  [types.ADD_WGPT_SOCIAL_MEDIA_POST]: MutationHelpers.setSingleRecord,
};

export default {
  namespaced: true,
  actions,
  state,
  getters,
  mutations,
};
